import { render, staticRenderFns } from "./frontActividadEconomicaForm.vue?vue&type=template&id=a2bd687a&scoped=true&"
import script from "./frontActividadEconomicaForm.vue?vue&type=script&lang=js&"
export * from "./frontActividadEconomicaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bd687a",
  null
  
)

export default component.exports